import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    
    // FIX: Replace broken/flipped softbait image with corrected version
    const oldImg = this.querySelector('img[src*="col-softbait.jpg?v=1779549446"]');
    if (oldImg) {
      oldImg.src = 'https://cdn.shopify.com/s/files/1/0657/7641/8990/articles/softbait_fixed.jpg?v=1779574226';
      oldImg.style.transform = 'none';
      oldImg.style.maxWidth = '500px';
      oldImg.style.margin = '20px auto';
      oldImg.style.display = 'block';
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
